// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__RXn1f","title":"Dialog_title__3DHuI","element":"Dialog_element__2Q6Z7","button":"Dialog_button__1xvAs","description":"Dialog_description__3qS1A"};